import { HelmetDexteel, useUserContext } from "@dexteel/mesf-core";
import { useQuery } from "@tanstack/react-query";
import { CatalogSectionFamily } from "../../models/CatalogSectionFamily";
import { getSectionFamilies } from "../../repositories/CatalogSectionFamilyRepository";
import { TableSectionFamily } from "./components/TableSectionFamily";

export const useSectionFamilies = (
	sectionFamilyId?: number,
	onError?: (error: Error) => void,
) => {
	const {
		state: { defaultAreaId },
	} = useUserContext();
	return useQuery<CatalogSectionFamily[], Error>({
		queryKey: ["sectionFamilies", sectionFamilyId, defaultAreaId],
		queryFn: ({ signal }) =>
			getSectionFamilies({ sectionFamilyId, defaultAreaId }, signal),
		onError: onError,
	});
};

export const CatalogSectionPage = () => {
	return (
		<>
			<HelmetDexteel title="Section Families" />
			<TableSectionFamily />
		</>
	);
};
